import { useEffect, useState } from 'react';
import EditInput from '../../../../components/Input';
import { Flex } from 'antd';

export const GridTableTotalHeader = ({
  tableColumns,
  total,
  update,
  disabled,
  max,
}) => {
  const [totalDuration, setTotalDuration] = useState(total);

  useEffect(() => {
    setTotalDuration(total);
  }, [total]);

  return (
    <div style={{ backgroundColor: '#F0F0F0', display: 'flex' }}>
      <div
        style={{
          width: '33%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 0.75rem',
        }}
      >
        <span style={{ fontWeight: 600 }}>Total</span>
        <EditInput
          rowIndex={-1}
          colIndex={-1}
          update={update}
          value={Number(totalDuration.toFixed(2))}
          isTotalInput
          disabled
        />
      </div>
      {tableColumns.map((column, columnIndex) => (
        <Flex
          justify="center"
          style={{
            padding: '0.75rem',
            flex: '1 1 0',
            minWidth: 0,
          }}
          key={`header-${columnIndex}`}
        >
          <EditInput
            rowIndex={-1}
            colIndex={columnIndex}
            update={update}
            value={Number(column.total.toFixed(2))}
            isTotalInput
            disabled={disabled}
            max={max}
          />
        </Flex>
      ))}
    </div>
  );
};
